var map = {
	"./Stroke 1.png": 1827,
	"./Why Our Save the Dat.png": 1828,
	"./all_about_shipping@2x.png": 1829,
	"./ask_for_everything@2x.png": 1830,
	"./big-day@1x.png": 1831,
	"./big-day@2x.png": 1832,
	"./birds@1x.png": 1833,
	"./birds@2x.png": 1834,
	"./check-list@1x.png": 1835,
	"./check-list@2x.png": 1836,
	"./circle-better@1x.png": 1837,
	"./circle-better@2x.png": 1838,
	"./empty_rsvp.png": 1839,
	"./empty_rsvp2x.png": 1840,
	"./envelope.png": 781,
	"./envelope.svg": 1841,
	"./envelope@2x.png": 1842,
	"./events_doodle.png": 675,
	"./events_doodle.svg": 1843,
	"./gifts@1x.png": 1844,
	"./gifts@2x.png": 1845,
	"./guest-list@1x.png": 1846,
	"./guest-list@2x.png": 1847,
	"./guest.png": 1848,
	"./guest.svg": 1849,
	"./guest2x.png": 1850,
	"./guest_approved@2x.png": 1851,
	"./invitations@1x.png": 1852,
	"./invitations@2x.png": 1853,
	"./invites_paper.svg": 1854,
	"./invites_paper@1x.png": 1855,
	"./invites_paper@2x.png": 1856,
	"./laptop-one-heart.png": 1857,
	"./laptop-one-heart@2x.png": 1858,
	"./laptop@1x.png": 1859,
	"./laptop@2x.png": 1860,
	"./long-page-checklist.png": 1861,
	"./long-page-checklist@2x.png": 1862,
	"./make_it_personal@2x.png": 1863,
	"./namecard-with-name.png": 1864,
	"./namecard-with-name@2x.png": 1865,
	"./namecard_no_name.svg": 676,
	"./namecard_with_name.svg": 1866,
	"./namecard_with_question_marks.svg": 374,
	"./no_address.png": 1867,
	"./no_address2x.png": 1868,
	"./onboarding_1.png": 1869,
	"./onboarding_1@2x.png": 1870,
	"./onboarding_2.png": 1871,
	"./onboarding_2@2x.png": 1872,
	"./onboarding_3.png": 1873,
	"./onboarding_3@2x.png": 1874,
	"./onboarding_4.png": 1875,
	"./onboarding_4@2x.png": 1876,
	"./red-star-left@1x.png": 1877,
	"./red-star-left@2x.png": 1878,
	"./red-star-right@1x.png": 1879,
	"./red-star-right@2x.png": 1880,
	"./registry_publish_champagne.svg": 1881,
	"./rsvp@1x.png": 1882,
	"./rsvp@2x.png": 1883,
	"./save-the-date@1x.png": 1884,
	"./save-the-date@2x.png": 1885,
	"./sparkle-left.svg": 737,
	"./sparkle-right.svg": 738,
	"./sparkle-up.svg": 786,
	"./ta-da.png": 1886,
	"./ta-da@2x.png": 1887,
	"./talk.svg": 1888,
	"./talk@1x.png": 739,
	"./talk@2x.png": 740,
	"./timeline-line-dark@1x.png": 1889,
	"./timeline-line-dark@2x.png": 1890,
	"./timeline-line@1x.png": 1891,
	"./timeline-line@2x.png": 1892,
	"./tips.svg": 741,
	"./underline_long@1x.png": 1893,
	"./underline_long@2x.png": 1894,
	"./underline_sm@1x.png": 1895,
	"./underline_sm@2x.png": 1896,
	"./website_publish_confetti.svg": 677,
	"./wedding-websites@1x.png": 1897,
	"./wedding-websites@2x.png": 1898,
	"./wedding_help.png": 787,
	"./wedding_help.svg": 1899,
	"./wedding_help@2x.png": 1900
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 386;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 386
// module chunks = 47